module.exports = __webpack_public_path__ + "static/img_5233-0056b9818d55fa344eaa2d664f4872fb.webp";